import { getSeatsInventory } from 'pricing-pages-lib/api/SeatsInventoryApi';
import { SEATS_INVENTORY } from './constants/RequestedDataTypes';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchSeatsInventoryRequestTypes = createRequestTypes(SEATS_INVENTORY);
export const FetchSeatsInventoryActions = createRequestActions(FetchSeatsInventoryRequestTypes);
export const fetchSeatsInventoryData = () => makeFetchRequest({
  requestActions: FetchSeatsInventoryActions,
  fetch: getSeatsInventory
});